<div class="card" *ngIf="showPreview">
  <div class="card-header" >Preview </div>
  <ul class="list-group list-group-flush" >
    <li class="list-group-item">
      <app-upload-file-detail [path]="pathToDatabase" [dbType]="dbType" [fileUpload]='fileUploads' [storagePath]="storagePath"  ></app-upload-file-detail>
    </li>
  </ul>
</div>
